module.exports = __webpack_public_path__ + "img/svg_withdrawalRequest.5bd5a82d.svg";